function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { EventContentWrapper, EventSubtitleSkeleton } from './styles';

var Skeleton = function Skeleton(_ref) {
  var rest = _extends({}, _ref);

  return /*#__PURE__*/React.createElement(EventContentWrapper, rest, /*#__PURE__*/React.createElement(EventSubtitleSkeleton, {
    width: 140
  }), /*#__PURE__*/React.createElement(EventSubtitleSkeleton, {
    width: 100
  }));
};

Skeleton.defaultProps = {
  variant: 'h6'
};
export default Skeleton;